// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"83c86bc8","977":"6ad994a7"}[chunkId] + ".chunk.js";
};